import React from 'react';

// Platform Icon Components
export const MetaIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M6.897 4h-.024l-.031 2.615h.022c1.715 0 3.046 1.357 5.94 6.246l.175.297.012.02 1.62-2.438-.012-.019a48.763 48.763 0 00-1.098-1.716 28.01 28.01 0 00-1.175-1.629C10.413 4.932 8.812 4 6.896 4z" fill="url(#meta-fill-0)"/>
    <path d="M6.873 4C4.95 4.01 3.247 5.258 2.02 7.17a4.352 4.352 0 00-.01.017l2.254 1.231.011-.017c.718-1.083 1.61-1.774 2.568-1.785h.021L6.896 4h-.023z" fill="url(#meta-fill-1)"/>
    <path d="M2.019 7.17l-.011.017C1.2 8.447.598 9.995.274 11.664l-.005.022 2.534.6.004-.022c.27-1.467.786-2.828 1.456-3.845l.011-.017L2.02 7.17z" fill="url(#meta-fill-2)"/>
    <path d="M2.807 12.264l-2.533-.6-.005.022c-.177.918-.267 1.851-.269 2.786v.023l2.598.233v-.023a12.591 12.591 0 01.21-2.44z" fill="url(#meta-fill-3)"/>
    <path d="M2.677 15.537a5.462 5.462 0 01-.079-.813v-.022L0 14.468v.024a8.89 8.89 0 00.146 1.652l2.535-.585a4.106 4.106 0 01-.004-.022z" fill="url(#meta-fill-4)"/>
    <path d="M3.27 16.89c-.284-.31-.484-.756-.589-1.328l-.004-.021-2.535.585.004.021c.192 1.01.568 1.85 1.106 2.487l.014.017 2.018-1.745a2.106 2.106 0 01-.015-.016z" fill="url(#meta-fill-5)"/>
    <path d="M10.78 9.654c-1.528 2.35-2.454 3.825-2.454 3.825-2.035 3.2-2.739 3.917-3.871 3.917a1.545 1.545 0 01-1.186-.508l-2.017 1.744.014.017C2.01 19.518 3.058 20 4.356 20c1.963 0 3.374-.928 5.884-5.33l1.766-3.13a41.283 41.283 0 00-1.227-1.886z" fill="#0082FB"/>
    <path d="M13.502 5.946l-.016.016c-.4.43-.786.908-1.16 1.416.378.483.768 1.024 1.175 1.63.48-.743.928-1.345 1.367-1.807l.016-.016-1.382-1.24z" fill="url(#meta-fill-6)"/>
    <path d="M20.918 5.713C19.853 4.633 18.583 4 17.225 4c-1.432 0-2.637.787-3.723 1.944l-.016.016 1.382 1.24.016-.017c.715-.747 1.408-1.12 2.176-1.12.826 0 1.6.39 2.27 1.075l.015.016 1.589-1.425-.016-.016z" fill="#0082FB"/>
    <path d="M23.998 14.125c-.06-3.467-1.27-6.566-3.064-8.396l-.016-.016-1.588 1.424.015.016c1.35 1.392 2.277 3.98 2.361 6.971v.023h2.292v-.022z" fill="url(#meta-fill-7)"/>
    <path d="M23.998 14.15v-.023h-2.292v.022c.004.14.006.282.006.424 0 .815-.121 1.474-.368 1.95l-.011.022 1.708 1.782.013-.02c.62-.96.946-2.293.946-3.91 0-.083 0-.165-.002-.247z" fill="url(#meta-fill-8)"/>
    <path d="M21.344 16.52l-.011.02c-.214.402-.519.67-.917.787l.778 2.462a3.493 3.493 0 00.438-.182 3.558 3.558 0 001.366-1.218l.044-.065.012-.02-1.71-1.784z" fill="url(#meta-fill-9)"/>
    <path d="M19.92 17.393c-.262 0-.492-.039-.718-.14l-.798 2.522c.449.153.927.222 1.46.222.492 0 .943-.073 1.352-.215l-.78-2.462c-.167.05-.341.075-.517.073z" fill="url(#meta-fill-10)"/>
    <path d="M18.323 16.534l-.014-.017-1.836 1.914.016.017c.637.682 1.246 1.105 1.937 1.337l.797-2.52c-.291-.125-.573-.353-.9-.731z" fill="url(#meta-fill-11)"/>
    <path d="M18.309 16.515c-.55-.642-1.232-1.712-2.303-3.44l-1.396-2.336-.011-.02-1.62 2.438.012.02.989 1.668c.959 1.61 1.74 2.774 2.493 3.585l.016.016 1.834-1.914a2.353 2.353 0 01-.014-.017z" fill="url(#meta-fill-12)"/>
    <defs>
      <linearGradient id="meta-fill-0" x1="75.897%" x2="26.312%" y1="89.199%" y2="12.194%">
        <stop offset=".06%" stopColor="#0867DF"/>
        <stop offset="45.39%" stopColor="#0668E1"/>
        <stop offset="85.91%" stopColor="#0064E0"/>
      </linearGradient>
      <linearGradient id="meta-fill-1" x1="21.67%" x2="97.068%" y1="75.874%" y2="23.985%">
        <stop offset="13.23%" stopColor="#0064DF"/>
        <stop offset="99.88%" stopColor="#0064E0"/>
      </linearGradient>
      <linearGradient id="meta-fill-2" x1="38.263%" x2="60.895%" y1="89.127%" y2="16.131%">
        <stop offset="1.47%" stopColor="#0072EC"/>
        <stop offset="68.81%" stopColor="#0064DF"/>
      </linearGradient>
      <linearGradient id="meta-fill-3" x1="47.032%" x2="52.15%" y1="90.19%" y2="15.745%">
        <stop offset="7.31%" stopColor="#007CF6"/>
        <stop offset="99.43%" stopColor="#0072EC"/>
      </linearGradient>
      <linearGradient id="meta-fill-4" x1="52.155%" x2="47.591%" y1="58.301%" y2="37.004%">
        <stop offset="7.31%" stopColor="#007FF9"/>
        <stop offset="100%" stopColor="#007CF6"/>
      </linearGradient>
      <linearGradient id="meta-fill-5" x1="37.689%" x2="61.961%" y1="12.502%" y2="63.624%">
        <stop offset="7.31%" stopColor="#007FF9"/>
        <stop offset="100%" stopColor="#0082FB"/>
      </linearGradient>
      <linearGradient id="meta-fill-6" x1="34.808%" x2="62.313%" y1="68.859%" y2="23.174%">
        <stop offset="27.99%" stopColor="#007FF8"/>
        <stop offset="91.41%" stopColor="#0082FB"/>
      </linearGradient>
      <linearGradient id="meta-fill-7" x1="43.762%" x2="57.602%" y1="6.235%" y2="98.514%">
        <stop offset="0%" stopColor="#0082FB"/>
        <stop offset="99.95%" stopColor="#0081FA"/>
      </linearGradient>
      <linearGradient id="meta-fill-8" x1="60.055%" x2="39.88%" y1="4.661%" y2="69.077%">
        <stop offset="6.19%" stopColor="#0081FA"/>
        <stop offset="100%" stopColor="#0080F9"/>
      </linearGradient>
      <linearGradient id="meta-fill-9" x1="30.282%" x2="61.081%" y1="59.32%" y2="33.244%">
        <stop offset="0%" stopColor="#027AF3"/>
        <stop offset="100%" stopColor="#0080F9"/>
      </linearGradient>
      <linearGradient id="meta-fill-10" x1="20.433%" x2="82.112%" y1="50.001%" y2="50.001%">
        <stop offset="0%" stopColor="#0377EF"/>
        <stop offset="99.94%" stopColor="#0279F1"/>
      </linearGradient>
      <linearGradient id="meta-fill-11" x1="40.303%" x2="72.394%" y1="35.298%" y2="57.811%">
        <stop offset=".19%" stopColor="#0471E9"/>
        <stop offset="100%" stopColor="#0377EF"/>
      </linearGradient>
      <linearGradient id="meta-fill-12" x1="32.254%" x2="68.003%" y1="19.719%" y2="84.908%">
        <stop offset="27.65%" stopColor="#0867DF"/>
        <stop offset="100%" stopColor="#0471E9"/>
      </linearGradient>
    </defs>
  </svg>
);

export const GoogleIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 48 48">
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
  </svg>
);

export const YouTubeIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 461.001 461.001">
    <path fill="#F61C0D" d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"/>
  </svg>
);

export const TikTokIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 449.45 515.38">
    <path fill="#000000" d="M382.31 103.3c-27.76-18.1-47.79-47.07-54.04-80.82-1.35-7.29-2.1-14.8-2.1-22.48h-88.6l-.15 355.09c-1.48 39.77-34.21 71.68-74.33 71.68-12.47 0-24.21-3.11-34.55-8.56-23.71-12.47-39.94-37.32-39.94-65.91 0-41.07 33.42-74.49 74.48-74.49 7.67 0 15.02 1.27 21.97 3.44V190.8c-7.2-.99-14.51-1.59-21.97-1.59C73.16 189.21 0 262.36 0 352.3c0 55.17 27.56 104 69.63 133.52 26.48 18.61 58.71 29.56 93.46 29.56 89.93 0 163.08-73.16 163.08-163.08V172.23c34.75 24.94 77.33 39.64 123.28 39.64v-88.61c-24.75 0-47.8-7.35-67.14-19.96z"/>
  </svg>
);

export const PinterestIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="20" fill="#E60023"/>
    <path fill="#FFF" d="M24.4439087,11.4161377c-8.6323242,0-13.2153931,5.7946167-13.2153931,12.1030884c0,2.9338379,1.5615234,6.5853882,4.0599976,7.7484131c0.378418,0.1762085,0.581543,0.1000366,0.668457-0.2669067c0.0668945-0.2784424,0.4038086-1.6369019,0.5553589-2.2684326c0.0484619-0.2015381,0.0246582-0.3746338-0.1384277-0.5731201c-0.8269653-1.0030518-1.4884644-2.8461304-1.4884644-4.5645752c0-4.4115601,3.3399658-8.6799927,9.0299683-8.6799927c4.9130859,0,8.3530884,3.3484497,8.3530884,8.1369019c0,5.4099731-2.7322998,9.1584473-6.2869263,9.1584473c-1.9630737,0-3.4330444-1.6238403-2.9615479-3.6153564c0.5654297-2.3769531,1.6569214-4.9415283,1.6569214-6.6584473c0-1.5354004-0.8230591-2.8169556-2.5299683-2.8169556c-2.006958,0-3.6184692,2.0753784-3.6184692,4.8569336c0,1.7700195,0.5984497,2.9684448,0.5984497,2.9684448s-1.9822998,8.3815308-2.3453979,9.9415283c-0.4019775,1.72229-0.2453003,4.1416016-0.0713501,5.7233887l0,0c0.4511108,0.1768799,0.9024048,0.3537598,1.3687744,0.4981079l0,0c0.8168945-1.3278198,2.0349731-3.5056763,2.4864502-5.2422485c0.2438354-0.9361572,1.2468872-4.7546387,1.2468872-4.7546387c0.6515503,1.2438965,2.5561523,2.296936,4.5831299,2.296936c6.0314941,0,10.378418-5.546936,10.378418-12.4400024C36.7738647,16.3591919,31.3823242,11.4161377,24.4439087,11.4161377z"/>
  </svg>
);

export const MicrosoftIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 32 32">
    <rect x="17" y="17" width="10" height="10" fill="#FEBA08"/>
    <rect x="5" y="17" width="10" height="10" fill="#05A6F0"/>
    <rect x="17" y="5" width="10" height="10" fill="#80BC06"/>
    <rect x="5" y="5" width="10" height="10" fill="#F25325"/>
  </svg>
);

// Platform Icon Mapping
interface PlatformIconProps {
  platform: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const PlatformIcon: React.FC<PlatformIconProps> = ({ 
  platform, 
  className,
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const iconClassName = className || sizeClasses[size];

  const iconComponents = {
    meta: MetaIcon,
    facebook: MetaIcon, // Alias for Meta
    google: GoogleIcon,
    'google ads': GoogleIcon, // Handle "Google Ads"
    googleads: GoogleIcon, // Handle "googleads"
    youtube: YouTubeIcon,
    tiktok: TikTokIcon,
    pinterest: PinterestIcon,
    microsoft: MicrosoftIcon,
    'microsoft ads': MicrosoftIcon, // Handle "Microsoft Ads"
    microsoftads: MicrosoftIcon, // Handle "microsoftads"
  };

  const normalizedPlatform = platform.toLowerCase();
  const IconComponent = iconComponents[normalizedPlatform as keyof typeof iconComponents];

  if (!IconComponent) {
    // Fallback for unknown platforms - use a generic circle
    return (
      <div className={`${iconClassName} bg-gray-500 rounded-full flex items-center justify-center`}>
        <div className="w-1/2 h-1/2 bg-white rounded-full"></div>
      </div>
    );
  }

  return <IconComponent className={iconClassName} />;
};

// Platform info with colors (keeping existing color scheme)
export const platformInfo = {
  meta: { name: 'Meta', color: 'bg-blue-500', textColor: 'text-blue-600' },
  google: { name: 'Google', color: 'bg-red-500', textColor: 'text-red-600' },
  youtube: { name: 'YouTube', color: 'bg-red-600', textColor: 'text-red-600' },
  tiktok: { name: 'TikTok', color: 'bg-black', textColor: 'text-gray-900' },
  pinterest: { name: 'Pinterest', color: 'bg-red-400', textColor: 'text-red-600' },
  microsoft: { name: 'Microsoft', color: 'bg-blue-600', textColor: 'text-blue-600' }
};

export default PlatformIcon;